declare namespace $ {

	type $shm_hitalama_attach__files_shm_hitalama_file_attach_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_file_attach['files'] >
		,
		ReturnType< $shm_hitalama_attach['files'] >
	>
	type $mol_paragraph__title_shm_hitalama_file_attach_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_file_attach['filename'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $shm_hitalama_file_attach extends $mol_view {
		files( next?: readonly(any)[] ): readonly(any)[]
		File( ): $shm_hitalama_attach
		filename( ): string
		Name( ): $mol_paragraph
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=attach.view.tree.d.ts.map